import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { luuBlob } from '../../../lib/api/http';
import { useToast } from '../../../lib/toast';
import { tieuDeTuTenTep } from '../nghiep-vu/bien-ban';
import type { DinhDangXuat, Phien } from '../types';
import { useGhiPhien } from './useBienBan';

/** Xuất biên bản, dùng chung bảng danh sách và thanh công cụ: tải về máy rồi báo, lỗi nói bằng toast vì không có ô nào để đặt. */
export function useXuatPhien() {
  const { t } = useT();
  const toast = useToast();
  const dichLoi = useLoi();
  const { xuat } = useGhiPhien();
  return {
    dangXuat: xuat.isPending ? xuat.variables?.dinhDang : undefined,
    xuat: (p: Pick<Phien, 'id' | 'title'>, dinhDang: DinhDangXuat) =>
      xuat.mutate(
        { id: p.id, dinhDang, tenMacDinh: `${tieuDeTuTenTep(p.title) || p.id}.${dinhDang}` },
        {
          onSuccess: ({ blob, ten }) => {
            luuBlob(blob, ten);
            toast.success(t('bienBan.daXuat', { ten }));
          },
          onError: (e) => toast.error(t('bienBan.loiXuat', { loi: dichLoi(e) })),
        },
      ),
  };
}
